define('common/utils/template',[
    'common/utils/_'
], function (
    _
) {

    return _.template.bind(_);

});

